import { useEffect } from "react";
import { getCurrentFacilityId } from "../services/memberManagementService";
import {
  UserGeneralInfoContextKeys,
  UserStore,
} from "../store/userGeneralInfoStore";
import { useAuthSelector } from "../state/AuthStoreProvider";
import type { AuthRootState } from "../state/store";

export function useFacilityData(
  isRbacTokenLoaded: boolean,
  facilityId: string | undefined,
) {
  const { data: singleHealthFacilityDetails } = useAuthSelector(
    (state: AuthRootState) => state.singleHealthFacilityDetails,
  );

  useEffect(() => {
    if (facilityId && facilityId.trim() !== "") {
      UserStore.setItem(
        UserGeneralInfoContextKeys.HEALTHCARE_FACILITY_ID,
        facilityId,
      );
    }
  }, [facilityId]);

  useEffect(() => {
    if (!isRbacTokenLoaded || !singleHealthFacilityDetails) {
      return;
    }

    let facilityIdForOptions = getCurrentFacilityId() || facilityId;

    if (
      singleHealthFacilityDetails.is_external_organization &&
      singleHealthFacilityDetails.corresponding_internal_org_id
    ) {
      UserStore.setItem(
        UserGeneralInfoContextKeys.INTERNAL_ORGANIZATION_FACILITY_ID,
        singleHealthFacilityDetails.corresponding_internal_org_id,
      );

      facilityIdForOptions =
        singleHealthFacilityDetails.corresponding_internal_org_id;
    }
  }, [isRbacTokenLoaded, singleHealthFacilityDetails, facilityId]);
}
